import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Loader extends React.Component {
  render() {
    const { type, size, ...rest } = this.props;
    return (
      <StyledLoader className={`loader ${size} loader--${type}`} {...rest}><span></span></StyledLoader>
    )
  }
}

Loader.defaultProps = {
  type: 'color',
  size: 'large',
}

Loader.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
}

const StyledLoader = styled.div`
&.loader {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    font-size: 0;
}

&.loader::before,
&.loader::after {
    content: "";
}

&.large::before,
&.large span,
&.large::after {
    width: 12px;
    height: 12px;
    -webkit-animation: anim 0.8s infinite ease;
    animation: anim 0.8s infinite ease;
}

&.large span,
&.large::after {
    margin-left: 8px;
}

&.medium::before,
&.medium span,
&.medium::after {
    width: 8px;
    height: 8px;
    -webkit-animation: anim 0.8s infinite ease;
    animation: anim 0.8s infinite ease;
}

&.medium span,
&.medium::after {
    margin-left: 5px;
}

&.small::before,
&.small span,
&.small::after {
    width: 6px;
    height: 6px;
    -webkit-animation: anim 0.8s infinite ease;
    animation: anim 0.8s infinite ease;
}

&.small span,
&.small::after {
    margin-left: 4px;
}

&.extra-small::before,
&.extra-small span,
&.extra-small::after {
    width: 5px;
    height: 5px;
    -webkit-animation: anim 0.8s infinite ease;
    animation: anim 0.8s infinite ease;
}

&.extra-small span,
&.extra-small::after {
    margin-left: 3px;
}

&.loader::before,
&.loader span,
&.loader::after {
    display: inline-block;
    border-radius: 50%;
}

&.loader--light::before,
&.loader--light span,
&.loader--light::after {
    background-color: white;
}

&.loader--dark::before,
&.loader--dark span,
&.loader--dark::after {
    background-color: black;
}

&.loader--color::before,
&.loader--color span,
&.loader--color::after {
    background-color: #1A65FF;
}

&.loader span {
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
}

&.loader::after {
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
}

@-webkit-keyframes anim {
    0% {
        -webkit-transform: translateY(40%);
        transform: translateY(40%);
        opacity: 0.2;
    }
    50% {
        -webkit-transform: translateY(-40%);
        transform: translateY(-40%);
        opacity: 0.6;
    }
    100% {
        -webkit-transform: translateY(40%);
        transform: translateY(40%);
        opacity: 0.2;
    }
}

@keyframes anim {
    0% {
        -webkit-transform: translateY(40%);
        transform: translateY(40%);
        opacity: 0.2;
    }
    50% {
        -webkit-transform: translateY(-40%);
        transform: translateY(-40%);
        opacity: 0.6;
    }
    100% {
        -webkit-transform: translateY(40%);
        transform: translateY(40%);
        opacity: 0.2;
    }
}
`

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Parts/Loader.jsx